import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM10.8 20.4V18H13.2V20.4H10.8ZM14.604 12.204L15.684 11.1C16.908 9.87604 17.328 7.77604 15.912 5.82004C14.832 4.32004 13.092 3.37204 11.268 3.66004C9.40799 3.94804 7.90799 5.29204 7.39199 7.05604C7.19999 7.72804 7.67999 8.40004 8.37599 8.40004H8.73599C9.20399 8.40004 9.57599 8.06404 9.71999 7.62004C10.116 6.48004 11.352 5.72404 12.684 6.09604C13.524 6.33604 14.196 7.06804 14.352 7.93204C14.508 8.77204 14.244 9.56404 13.692 10.092L12.204 11.604C11.7 12.108 11.304 12.732 11.064 13.428C10.896 13.92 10.8 14.448 10.8 15V15.6H13.2C13.2 15.048 13.26 14.616 13.356 14.232C13.572 13.368 14.004 12.816 14.604 12.204Z";

export default function HelpCircle(props: IconProps) {
  return (
    <SVGIcon path={path} fillRule="evenodd" clipRule="evenodd" {...props} />
  );
}
